










































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import HeaderBar from '@/components/header-bar/index.vue'
import FormItem from '@/components/form-item/index.vue'
import SubmitTransition from '@/components/submit-transition/index.vue'
import CheckBox from '@/components/check-box/index.vue'
import SelectItem from '@/components/Select.vue'
import Mtextarea from '@/components/m-textarea/index.vue'
import { uploadChannel } from '@/constants/uploadFrom'
// import ImgCheckAction from '@/utils/imgcheck'
import { GetTag } from '@/services/uploads'
import { addPlaylist } from '@/services/broadcast'
import Mprotocol from '@/components/m-protocol/index.vue'
import EditorCropper from '@/components/EditorCropper/index.vue' //裁剪模块

interface CreateForm {
  title: string // 标题
  subTitle: string
  tagCategory: string
  classId: string
  tags: any
  story: string
  coverImg1: string
  coverImg3: string
}

@Component({
  components: {
    HeaderBar,
    FormItem,
    CheckBox,
    Mtextarea,
    SelectItem,
    SubmitTransition,
    Mprotocol,
    EditorCropper,
  },
})
export default class Create extends Vue {
  public channelList: UploadVideoAPI.Channel[] = uploadChannel

  formData: CreateForm = {
    title: '', // 标题
    subTitle: '',
    tagCategory: '',
    coverImg1: '',
    coverImg3: '',
    classId: '',
    tags: [] || '', //
    story: '',
  }

  coverImg = ''
  coverImg1 = ''
  coverImgHeng = ''
  previewImages = {
    heng: '',
    shu: '',
  }
  coverImgShu = ''
  CropperData = {
    cropperDialogVisible: false,
  }
  isAgree = false
  inputAction: any = null
  imgType = ''
  checked = false
  $toast: any
  isClass = false
  statusTxt = '提交成功'
  publishSuccess = false
  showSmallLoad = false
  showBigLoad = false
  uploadTag: Set<string> = new Set()

  tags: Array<string> = []
  taglList: Array<object> = []

  @Watch('formData.tagCategory')
  watchValue() {
    this.fetchTag()
    this.isClass = true
  }

  get userInfoInapp() {
    return this.$store.state.userInfoInapp
  }

  get classify() {
    return this.$store.state.uploads.classify
  }

  // eslint-disable-next-line complexity, max-statements
  async submit() {
    if (!this.formData.title) {
      return this.$toast('播单标题')
    }

    if (!this.formData.subTitle) {
      return this.$toast('播单副标题')
    }

    if (!this.formData.classId) {
      return this.$toast('请选择频道')
    }

    if (!this.formData.tags) {
      return this.$toast('请选择分类')
    }

    if (this.coverImgHeng == '') {
      return this.$toast('请上传大封面')
    }

    if (this.coverImgShu == '') {
      return this.$toast('请上传小封面')
    }

    // 提交申请
    if (!this.checked) {
      return this.$toast('请同意协议')
    }

    this.formData.tags = this.formData.tags.join(',')

    let data = {
      ...this.formData,
      coverImg1: this.coverImgHeng,
      coverImg3: this.coverImgShu,
    }
    if (this.uploadTag.size > 0) {
      if (this.uploadTag.has('coverImgHeng') && data.coverImg1) {
        let url = new URL(data.coverImg1)
        data.coverImg1 = url.pathname
      }
      if (this.uploadTag.has('coverImgShu') && data.coverImg3) {
        let url = new URL(data.coverImg3)
        data.coverImg3 = url.pathname
      }
    }
    const res = await addPlaylist(data)

    if (res && res.code == 200) {
      this.uploadTag.clear()
      this.publishSuccess = true
    } else {
      this.$toast('提交失败,重新提交')
    }
  }

  async fetchTag() {
    const { data } = await GetTag(this.formData.tagCategory)
    const list: Array<object> = []
    if (data && data.length) {
      for (let i = 0; i < data.length; i++) {
        list.push({
          id: data[i],
          text: data[i],
          disabled: false,
        })
      }
    }
    this.taglList = list
  }

  // uploaderOnSuccessHandler(info: any) {
  //   if (this.imgType == 1) {
  //     this.coverImg = info.url
  //     this.showBigLoad = false
  //   }
  //   if (this.imgType == 2) {
  //     this.coverImg1 = info.url
  //     this.showSmallLoad = false
  //   }
  // }

  // uploaderOnErrorHandler(info: any) {
  //   this.showBigLoad = false
  //   this.showSmallLoad = false
  //   this.$toast(info)
  // }

  getImg(e: Event, type: 'heng' | 'shu') {
    const target: HTMLInputElement = e.target as HTMLInputElement
    const files: FileList | null = target.files

    if (files && files.length) {
      const file = files[0]
      const fileMaxSize = 1024 * 5 //最大5M
      const size = file.size / 1024

      if (!/image\/\w+/.test(file.type) || size > fileMaxSize) {
        this.$toast('图片格式文件错误或图片大小大于5M,请重新选择')
        target.value = ''
        return
      }

      this.imgType = type
      type == 'heng' ? (this.showBigLoad = true) : (this.showSmallLoad = true)

      const reader = new FileReader()
      reader.onload = (event: any) => {
        let imgParam = {}
        if (type === 'heng') {
          imgParam = {
            autoCropHeight: 422,
            autoCropWidth: 750,
            fixedNumber: [16, 9],
          }
        } else if (type === 'shu') {
          imgParam = {
            autoCropHeight: 478,
            autoCropWidth: 342,
            fixedNumber: [5, 7],
          }
        }
        this.CropperData = Object.assign(
          this.CropperData,
          {
            imgBase64: event.target.result,
            file: file,
            fixedBox: true,
            cropperDialogVisible: true,
          },
          imgParam
        )
        this.previewImages[type] = URL.createObjectURL(file)
        console.log(this.CropperData)
      }
      if (file) {
        reader.readAsDataURL(file)
      }
    }
  }

  refresh() {
    const vedioInputs: any = this.$refs.fileInput
    if (vedioInputs && vedioInputs.length) {
      for (const input of vedioInputs) {
        input.value = ''
      }
    }
  }

  cropperFinsh(data: string, key: string, file: any) {
    this.refresh()
    if (data == 'fail') {
      this.CropperData = {
        cropperDialogVisible: false,
      }
      this.showSmallLoad = false
      this.showBigLoad = false
      return
    }
    if (this.imgType == 'heng') {
      this.previewImages.heng = URL.createObjectURL(file)
      this.coverImgHeng = data
      this.showBigLoad = false
      this.uploadTag.add('coverImgHeng')
    }
    if (this.imgType == 'shu') {
      this.previewImages.shu = URL.createObjectURL(file)
      this.coverImgShu = data
      this.showSmallLoad = false
      this.uploadTag.add('coverImgShu')
    }
    this.CropperData = {
      cropperDialogVisible: false,
    }
  }

  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0
    this.$store.dispatch('uploads/fetchVideoTag')
  }
}
